<template>
  <div class="notification__chat">
    <div class="notification__header">
      <p class="notification__title">
        Заказ: {{ notification.eventId }}
      </p>
      <span
        class="notification__close"
        @click="hideNotification">x</span>
    </div>
    <div class="notification__body">
      <transition-group
        name="notification-chat-message"
        tag="div">
        <div
          :key="lastItem.created_at"
          class="notification__chat-message">
          {{ lastItem.message }}
        </div>
      </transition-group>
      <p
        v-if="unreadMessagesCount"
        class="notification__unread">
        {{ unreadMessagesCount }}
      </p>
    </div>
    <div class="notification__footer">
      <p
        class="notification__link admin-button admin-button--blue"
        @click="toOrder">
        К заказу
      </p>
      <p class="notification__date">
        {{ notificationDate }}
      </p>
    </div>
  </div>
</template>

<script>
import {
  // eslint-disable-next-line no-unused-vars
  mapState, mapGetters, mapMutations, mapActions,
} from 'vuex';

export default {
  name: 'NotificationsItemChats',

  props: {
    notification: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters('notifications', ['unreadCountByEntityId']),

    unreadMessagesCount() {
      return this.unreadCountByEntityId({ id: this.notification.eventId, entity: 'chats' });
    },

    lastItem() {
      return this.notification.items[this.notification.items.length - 1];
    },

    notificationDate() {
      const date = new Date(this.lastItem.created_at);

      return date.toLocaleDateString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    },
  },

  methods: {
    toOrder() {
      if ((this.notification.eventName === 'new_order'
        && this.$route.name !== 'admin-orders__order-main')
        || (this.$route.name === 'admin-orders__order-main' && this.$route.params.id !== this.notification.eventId)
        || (this.notification.eventName === 'order_custom_sale_payed')
      ) {
        this.$router.push({ name: 'admin-orders__order-main', params: { id: this.notification.eventId } });
      }

      this.$emit('hide', this.notification.id);
    },

    hideNotification() {
      this.$emit('hide', this.notification.id);
    },
  },
};
</script>

<style lang="scss" scoped>
  .notification__body {
    position: relative;
  }

  .notification__chat-message {
    min-height: 31px;
  }

  .notification-chat-message-enter-active {
    transition: transform .25s cubic-bezier(0.0, 0.0, 0.2, 1), opacity .25s cubic-bezier(0.0, 0.0, 0.2, 1);
  }

  .notification-chat-message-leave-active {
    transition: transform .2s cubic-bezier(0.4, 0.0, 1, 1), opacity .2s cubic-bezier(0.4, 0.0, 1, 1);
  }

  .notification-chat-message-enter {
    opacity: 0;
    transform: translateY(31px);
  }

  .notification-chat-message-enter-to {
    opacity: 1;
    transform: translateY(0);
  }

  .notification-chat-message-leave-to /* .list-leave-active до версии 2.1.8 */ {
    opacity: 0;
    transform: translateY(-31px);
    position: absolute;
    top: 0;
    left: 0;
  }

  .notification__footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .notification__date {
    font-size: 1.1rem;
  }
</style>
